/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import DefaultApplication from "./components/Application";

export default function getApplication(application) {
  if (!application) {
    return DefaultApplication;
  }

  if (typeof application !== "string") {
    console.warn(
      "Exported Application is not a string, danger to expose unwanted data" +
      " to the frontend",
    );

    return application;
  }

  // Extension specified to avoid packing README.md.
  return require(`./customApplications/${application}.jsx`);
}



// WEBPACK FOOTER //
// ../render/getApplication.js